import { render, staticRenderFns } from "./custom-card.vue?vue&type=template&id=12929464&scoped=true"
import script from "./custom-card.vue?vue&type=script&lang=js"
export * from "./custom-card.vue?vue&type=script&lang=js"
import style0 from "./custom-card.vue?vue&type=style&index=0&id=12929464&scoped=true&lang=css"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12929464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/frontend_src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12929464')) {
      api.createRecord('12929464', component.options)
    } else {
      api.reload('12929464', component.options)
    }
    module.hot.accept("./custom-card.vue?vue&type=template&id=12929464&scoped=true", function () {
      api.rerender('12929464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "custom-card.vue"
export default component.exports